/**
 * Filtering and ordering for the Encoders page's lists.
 *
 * Every word typed must appear somewhere in what the row says about itself
 * (name, source, encodes...), in any order and any case - "sib main" finds
 * SIB1XV-MAIN. Running things come first, then anything starting or stopping,
 * then the rest, each by name.
 */
export function matches(query: string, ...fields: (string | null | undefined)[]): boolean {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const hay = fields.filter(Boolean).join(' ').toLowerCase();
  return words.every((w) => hay.includes(w));
}

const rank = (state: string) =>
  state === 'running' ? 0 : ['starting', 'stopping', 'creating', 'updating', 'deleting'].includes(state) ? 1 : state === 'failed' ? 2 : 3;

export function runningFirst<T extends { state: string; name: string }>(list: T[]): T[] {
  return [...list].sort((a, b) => rank(a.state) - rank(b.state) || a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }));
}
